import { useEffect } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Content from './_Content'

const UpdatesWithCEOPage = () => {
  useEffect(() => {
    track(trackingEvents.productUpdates.viewUpdatesWithCEO, {})
  }, [])

  return (
    <ResponsivePage.Body showHeader={false} variant="wide">
      <Box width="full" gap="s32" alignSelf="center" style={{ maxWidth: '1440px' }}>
        <Content />
      </Box>
    </ResponsivePage.Body>
  )
}

export default UpdatesWithCEOPage
